<template>
  <template v-if="store.isAuthenticated">
    <RouterView />
  </template>

  <div v-else-if="!authError" class="app-boot">
    <div class="app-boot__spinner" aria-label="Laden" />
  </div>

  <div v-else class="app-boot app-boot--error">
    <h1>Er ging iets mis</h1>
    <p>{{ authErrorMessage }}</p>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useGameStore } from '@/stores/game'
import { readEntryToken, clearEntryToken } from '@/services/entryToken'

const store = useGameStore()
const router = useRouter()

const authError = ref(false)
const authErrorMessage = ref('')

onMounted(async () => {
  // V3-09: index.html already took the token out of the address bar; see services/entryToken.js.
  const orderKey = readEntryToken()
  try {
    await store.authenticate(orderKey ? { token: orderKey } : {})
    clearEntryToken()
    router.replace({ name: initialRoute() })
  } catch (e) {
    // Keep the token only after a network error, so a refresh can retry; once the server
    // has answered it is spent or refused.
    if (e?.status) clearEntryToken()
    authError.value = true
    authErrorMessage.value = e?.message || 'Authenticatie mislukt'
  }
})

function initialRoute() {
  if (store.activeGame) return 'game' // §6 resume unfinished minigame
  if (!store.seenGlobalIntro) return 'intro' // §3 first visit → intro → uitleg
  return 'home'
}
</script>

<style lang="scss">
.app-boot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sp-4);
  min-height: 100vh;
  min-height: 100dvh;
  padding: var(--sp-7);
  text-align: center;
  color: var(--c-on-brand);
  background: var(--grad-brand);

  &--error {
    color: var(--c-white);
  }
}

.app-boot__spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: app-spin 0.9s linear infinite;
}

@keyframes app-spin {
  to {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--dur-base) var(--ease-out);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
